import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { TextError } from '.';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';

export function TextArea(props) {
    const { label, name, required, validateOnChange = false, ...rest } = props;
    return (
        <>
            {label && (
                <label htmlFor={name}>
                    {label}{' '}
                    {required && (
                        <sup>
                            <FontAwesomeIcon icon={faAsterisk} />
                        </sup>
                    )}{' '}
                </label>
            )}
            <Field name={name}>
                {(props) => {
                    const { field, form } = props;
                    // Opt-in for forms that disable Formik's validateOnChange but still need this field to
                    // clear a cross-field error the moment it has a value, instead of waiting for a blur.
                    const handleChange = validateOnChange
                        ? (event) => form.setFieldValue(name, event.target.value, true)
                        : field.onChange;
                    return <textarea className="form-control" id={name} {...field} onChange={handleChange} {...rest} />;
                }}
            </Field>
            <ErrorMessage name={name} component={TextError} />
        </>
    );
}

export default TextArea;
